import { Component, OnDestroy, OnInit } from '@angular/core';
import { fadeIn } from '../../../../../animations/form-error';
import { BasePageComponent } from '../../../../base-page';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { IOption } from '../../../../../ui/interfaces/option';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { BaseService } from '../../../base/base.service';
import { AccountService } from '../../../../../services/ServiceEntity/account.service';
import { FormService } from '../../../../../shared/services/form.service';
import { TCModalService } from '../../../../../ui/services/modal/modal.service';
import { CountryService } from '../../../countries/countries.service';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../../../interfaces/app-state';
import { HttpService } from '../../../../../services/http/http.service';
import { takeUntil } from 'rxjs/operators';
import { ITypeInputFormColumnName, TypeInputFormColumnName } from '../type-input-form-column-name';
import { TypeInputFormService } from '../type-input-form.service';
import { TypeInputFormModel } from '../../../../../model/champs_formulaire/type-input-form.model';

/**
 * Permet de gérer l'ajout des countries.
 */
@Component({
  selector: 'app-type-input-form-add',
  templateUrl: './type-input-form-add.component.html',
  animations: [fadeIn]
})
export class TypeInputFormAddComponent extends BasePageComponent
  implements OnInit, OnDestroy {
  isSaving = false;
  successSave = false;
  serverHasError = false;

  theDialogRef: MatDialogRef<TypeInputFormAddComponent>;
  private subs$ = new Subject<void>();
  monies: IOption[] = [];
  editForm: UntypedFormGroup;
  column: ITypeInputFormColumnName;
  anotherMoney: boolean;

  constructor(
    private validatorService: TypeInputFormService,
    public baseService: BaseService,
    private accountService: AccountService,
    private formService: FormService,
    private dialogRef: MatDialogRef<TypeInputFormAddComponent>,
    private columnName: TypeInputFormColumnName,
    private fb: UntypedFormBuilder,
    private modal: TCModalService,
    private countryService: CountryService,
    store: Store<IAppState>, httpSv: HttpService) {
    super(store, httpSv);
    console.log('## construct type_input_form add');
    const column = this.columnName.getColumnName();
    this.theDialogRef = this.dialogRef;
    this.column = column;
    this.initForm(fb, column);
  }

  ngOnInit(): void {
    console.log('## init type_input_form add');
    this.accountService.identity().pipe(takeUntil(this.subs$))
      .subscribe(account => {
        super.setLoaded();
      });
  }

  ngOnDestroy() {
    console.log('## destroy type_input_form add');
    this.formService.free(this.subs$);
    this.successSave = false;
  }


  initForm(fb: UntypedFormBuilder, column: ITypeInputFormColumnName) {
    if (fb && column) {
      this.editForm = fb.group({
        [column.id]: [],
        [column.type]: [
          '',
          [Validators.required]
        ],
        [column.description]: ['']
      });
    }
  }

  /**
   * Enregistre un type de account ressource.
   */
  save() {
    console.log('## save type_input_form');
    this.isSaving = true;
    this.successSave = false;
    this.serverHasError = false;
    const c = this.createFromForm();
    console.log('## c: ', c);
    this.validatorService.create(c, this.validatorService.resourceUrl).subscribe(res => {
        console.log('## success create type_input_form');
        this.serverHasError = false;
        this.responseFromServer();
        this.editForm.reset();
        this.successSave = true;
        this.validatorService.getAllObjet();
      },
      err => {
        console.log('## error create type_input_form');
        this.responseFromServer();
        this.serverHasError = true;
        this.successSave = false;
      });
  }

  responseFromServer() {
    setTimeout(() => {
      this.isSaving = false;
    }, 300);
  }

  private createFromForm(): TypeInputFormModel {
    return {
      ...new TypeInputFormModel(),
      id: this.editForm.get([this.column.id]).value,
      type: this.editForm.get([this.column.type]).value,
      description: this.editForm.get([this.column.description]).value
    };
  }

  closeModal() {
    console.log('## close validator add');
    this.dialogRef.close();
    this.successSave = false;
    this.serverHasError = false;
    this.editForm.reset();
  }

  reset() {
    this.editForm.reset();
  }


}
